import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getSingleItemNavigationStyle } from './style';

export const SequentialNavigator = ({
  totalCount,
  currentIndex,
  onNext,
  onPrevious,
  i18n,
}) => {
  const classes = useDefaultStyles(getSingleItemNavigationStyle);

  const disableLeft = currentIndex === 0;
  const disableRight = currentIndex + 1 === totalCount;

  return (
    <div className={classes.sequentialNavigatorContainer}>
      {
          totalCount > 1 &&
            <button
              onClick={onPrevious}
              aria-label={i18n.getString(_TL_('Click to see previous item'))}
              disabled={disableLeft}
              className={classnames(
                classes.iconButton, classes.chevronLeft,
                disableLeft && classes.disabledIcon,
                'previous-button'
              )}
            />
        }
      <div className={classes.navigatorStatusContainer}>{`${currentIndex + 1}/${totalCount}`}</div>
      {
          totalCount > 1 &&
          <button
            className={classnames(
              classes.iconButton, classes.chevronRight,
              disableRight && classes.disabledIcon,
              'next-button'
            )}
            onClick={onNext}
            aria-label={i18n.getString(_TL_('Click to see next item'))}
            disabled={disableRight}
          />
        }
    </div>
  );
};

SequentialNavigator.propTypes = {
  totalCount: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
